import { render, staticRenderFns } from "./NotificationWidget.vue?vue&type=template&id=2b0553f6&scoped=true&"
import script from "./NotificationWidget.vue?vue&type=script&lang=js&"
export * from "./NotificationWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0553f6",
  null
  
)

export default component.exports